<nz-modal nzCentered [nzMaskClosable]="false" [nzClosable]="!isSyncing" class="custom-modal" [(nzVisible)]="isVisible"
    nzTitle="Sync Status from AfterShip" [nzWidth]="800" [nzFooter]="footerTpl" (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="isFetching">
            <nz-descriptions nzBordered nzLayout="vertical" nzSize="small" [nzColumn]="{ xxl: 4, xl: 4, lg: 4, md: 2, sm: 1, xs: 1 }">
                <nz-descriptions-item nzTitle="QB Invoice#">{{ order?.invoiceNo }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Tracking Number">{{ view?.trackingNumber || order?.qB_TrackingNo || '-' }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Carrier">{{ view?.carrier || '-' }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Last Updated">{{ view?.lastUpdated ? (view.lastUpdated | date: 'MM/dd/yyyy hh:mm a') : '-' }}</nz-descriptions-item>
            </nz-descriptions>

            <div nz-row nzJustify="space-between" nzAlign="middle" class="mt-1">
                <div nz-col class="modal-label">
                    <label>Current AfterShip Status</label>
                    <nz-tag class="ml-1" [nzColor]="tagColor(view?.liveStatus)">{{ label(view?.liveStatus) }}</nz-tag>
                </div>
                <div nz-col>
                    <button nz-button nzType="default" (click)="fetchStatus()" [nzLoading]="isFetching">
                        <span nz-icon nzType="sync" nzTheme="outline"></span> Fetch Latest Status
                    </button>
                </div>
            </div>

            <nz-alert *ngIf="view && !view.trackingFound" class="mt-1" nzType="warning" nzShowIcon
                [nzMessage]="view.message"></nz-alert>

            <ng-container *ngIf="view?.trackingFound">
                <div class="mt-1 modal-label"><label>Select status to sync</label></div>
                <nz-select [(ngModel)]="selectedStatus" [nzDisabled]="isSyncing" nzPlaceHolder="Select status"
                    style="width: 100%;">
                    <nz-option *ngIf="view.allowedStatus" [nzValue]="view.allowedStatus"
                        [nzLabel]="label(view.allowedStatus)"></nz-option>
                </nz-select>
                <p class="stock-status-text mt-1 mb-0">{{ helperText() }}</p>

                <nz-alert *ngIf="view.partsNotInWarehouse?.length && !view.inTransitCompleted" class="mt-1"
                    nzType="warning" nzShowIcon [nzMessage]="'Not in the warehouse yet: ' + view.partsNotInWarehouse.join(', ')"
                    nzDescription="In Transit still updates QuickBooks and Shopify, but this stock is not consumed until it is received."></nz-alert>
            </ng-container>

            <nz-alert *ngIf="result" class="mt-1" [nzType]="result.isSuccess ? 'success' : 'error'" nzShowIcon
                [nzMessage]="result.message" [nzDescription]="outcomesTpl"></nz-alert>
            <ng-template #outcomesTpl>
                <div *ngFor="let outcome of result?.outcomes">{{ outcome }}</div>
            </ng-template>

            <nz-alert class="mt-1" nzType="info" nzShowIcon
                nzMessage="If the status is In Transit, AfterShip keeps tracking the shipment until it is Delivered."></nz-alert>
        </nz-spin>
    </ng-container>
    <ng-template #footerTpl>
        <button nz-button class="modal-footer-btn" (click)="handleCancel()" [disabled]="isSyncing">Cancel</button>
        <button nz-button nzType="primary" (click)="syncStatus()" [nzLoading]="isSyncing"
            [disabled]="!view?.trackingFound || !selectedStatus || isFetching || isSyncing">Sync Status</button>
    </ng-template>
</nz-modal>
